// i18n area 'cluster' — locale sk-SK (task #171, onda 4): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/cluster.sk-SK.meta.json.
import type { enUS } from './cluster'

export const skSK: typeof enUS = {
  cluster: {
    // #233 — gli accessi di garanzia di un nodo (tradotto dall'italiano)
    nodeAccess: {
      title: 'Záručné prístupy',
      subtitle: 'Servisné dvere uzla: prístup len na čítanie s dočasným heslom a núdzový účet s heslom z trezoru',
      readOnlyTitle: 'Prístup len na čítanie (trantor)',
      stateNone: 'zatvorený',
      stateGranted: 'otvorený',
      stateGrantedPending: 'udelený — aplikuje sa na uzle',
      grantedBy: 'Udelil',
      grantedAt: 'Udelené',
      expiresAt: 'Vyprší',
      reason: 'Dôvod',
      endedAt: 'Zatvorený',
      endedReason: {
        revoked: 'odvolaný',
        expired: 'vypršal (TTL)',
        reboot: 'reštart uzla',
        failed: 'neaplikovaný (úloha zlyhala)'
      },
      grant: 'Udeliť prístup len na čítanie…',
      grantTitle: 'Udeliť prístup len na čítanie',
      grantSubmit: 'Udeliť',
      grantError: 'Udelenie bolo odmietnuté',
      grantConfirm: 'TVirt vygeneruje dočasné heslo pre systémového používateľa «trantor» (len čítanie: journal a diagnostika, bez sudo) a nastaví ho na uzle úlohou. Heslo sa zobrazí IBA raz, pri potvrdení; končí uplynutím, odvolaním alebo pri najbližšom reštarte uzla.',
      reasonLabel: 'Dôvod',
      reasonHint: 'Prečo otvárate dvere: zostane v udelení, v audite a v denníku',
      ttlLabel: 'Trvanie',
      ttlHours: '{n} h',
      revoke: 'Odvolať prístup len na čítanie…',
      revokeTitle: 'Odvolať prístup len na čítanie',
      revokeSubmit: 'Odvolať',
      revokeError: 'Odvolanie bolo odmietnuté',
      revokeConfirm: 'Udelenie končí okamžite a úloha znovu zamkne používateľa «trantor» na uzle: dočasné heslo prestane platiť.',
      passwordTitle: 'Heslo len na čítanie',
      passwordOnce: 'Toto heslo sa zobrazí IBA raz: skopírujte ho teraz. Nikde sa neukladá a nebude ho možné znova prečítať — ak ho stratíte, udeľte znova.',
      passwordUser: 'Používateľ',
      passwordLabel: 'Heslo',
      passwordHint: 'Platí do {until} alebo do najbližšieho reštartu uzla; použiteľné, keď je úloha udelenia dokončená. Prístup: ssh trantor@<adresa uzla>.',
      emergencyTitle: 'Posledný núdzový prístup (trantor-emergency)',
      lastLogin: '{time} cez {via} z {from}',
      lastLoginNone: 'žiadny nepozorovaný',
      lastLoginVia: {
        ssh: 'ssh',
        console: 'konzola',
        sudo: 'sudo',
        unknown: 'neznámy'
      },
      emergencyHint: 'Núdzový účet «trantor-emergency» (plné sudo) je vždy povolený s heslom vygenerovaným pri inštalácii uzla a uloženým v trezore: TVirt ho nepozná, nerotuje ani neobnovuje. Každé prihlásenie sa hlási tu a v denníku udalostí.'
    },
    nodeFirewall: {
      tab: 'Firewall',
      title: 'Firewall uzlov',
      subtitle: 'Postoj rulesetu nftables, ktorý každý uzol aplikuje sám na seba — jediný firewall uzla (firewalld je vypnutý)',
      modeLabel: 'Postoj',
      mode: {
        disabled: 'Vypnutý — žiadny ruleset na uzloch',
        permissive: 'Permisívny — počíta a loguje, nič nezahadzuje',
        enforced: 'Vynútený — vstúpi len odvodený register'
      },
      hint: {
        disabled: 'Ako dnes: uzly nenesú žiadny ruleset. Prepnite na permisívny, aby ste si PREČÍTALI, čo by sa zahodilo, skôr než sa to zahodí.',
        permissive: 'Každý uzol aplikuje svoj odvodený ruleset s policy accept: to, čo by vynútený režim zahodil, sa počíta a loguje (prefix v journali «tvirt-node would-drop:»). Nič sa neblokuje.',
        enforced: 'Každý uzol aplikuje svoj odvodený ruleset s policy drop: ssh a API odkiaľkoľvek, store / live migration / overlay / Ceph len od členov, listenery sieťových služieb z obsluhovanej siete. Každá zmena je apply s potvrdením — uzol, ktorému sa nepodarí potvrdiť, sa sám vráti späť.'
      },
      confirmTitle: 'Vynútiť firewall uzlov?',
      confirmBody: 'Každý uzol aplikuje ruleset s potvrdením: cez nové pravidlá sonduje backend, store a ssh pred uplynutím termínu a potvrdí — inak sa sám vráti k predchádzajúcemu rulesetu. Najprv si prečítajte počítadlá permisívneho režimu na uzloch.',
      confirmSubmit: 'Vynútiť',
      confirmCancel: 'Zrušiť',
      lensTitle: 'Firewall uzla',
      loadError: 'Nepodarilo sa načítať šošovku firewallu uzla',
      noReport: 'Zatiaľ žiadne hlásenie firewallu z tohto uzla — worker nahlási pri ďalšom prechode',
      firewalldActive: 'Na tomto uzle beží firewalld: firewall uzla sa odmieta aplikovať vedľa neho (zamaskujte firewalld)',
      conditionUnconfirmed: 'Zatiaľ žiadny potvrdený ruleset — uzol je otvorený',
      conditionRolledBack: 'Posledný apply sa vrátil späť — tá istá generácia sa neskúša znova, kým sa register nezmení alebo sa postoj znova nezmení',
      lastError: 'Posledná chyba',
      posture: 'Postoj',
      observedAt: 'Pozorované',
      desiredGeneration: 'Želaná generácia',
      componentTitle: 'Komponent uzla',
      componentSubtitle: 'tvirt-node-firewall — pri boote aplikuje potvrdený ruleset, nepotvrdený sám vráti späť',
      componentAbsent: 'Komponent zatiaľ nič nenahlásil',
      phase: 'Fáza',
      phases: {
        none: 'Nikdy neaplikovaný',
        applied: 'Aplikovaný — čaká na potvrdenie',
        confirmed: 'Potvrdený',
        rolledBack: 'Vrátený späť'
      },
      generation: 'Generácia',
      appliedAt: 'Aplikované',
      confirmedAt: 'Potvrdené',
      deadline: 'Termín rollbacku',
      lastRollback: 'Posledný rollback',
      registryTitle: 'Odvodený register',
      registrySubtitle: 'Porty, ktoré tento uzol otvára, podľa triedy a pôvodu — odvodené z klastra, nikdy neupravované ručne',
      registryEmpty: 'Nič odvodené — postoj vypnutý bez potvrdeného rulesetu, alebo zatiaľ žiadne hlásenie',
      colClass: 'Trieda',
      colPort: 'Port',
      colSource: 'Zdroj',
      colOrigin: 'Pôvod',
      classes: {
        public: 'Verejná',
        internode: 'Medziuzlová',
        tenant: 'Tenant'
      },
      sourceMembers: 'len členovia',
      sourceAnywhere: 'odkiaľkoľvek',
      sourceBridge: 'na {iface}'
    },
    derivationDerived: 'odvodený',
    derivationDiverged: 'odchýlený',
    derivationDerivedTip: 'Sieťový dokument je ODVODENÝ z fabric {fabric} a stále sa zhoduje s renderom na aktuálnych vstupoch — kliknite pre plán derivácie.',
    derivationDivergedTip: 'Derivácia z fabric {fabric} sa po poslednom apply zmenila (fabric, kabeláž, roly alebo referencie) — kliknite pre čakajúci diff.',
    derivationRetiring: {
      one: '{n} adresa sa vyprázdňuje',
      few: '{n} adresy sa vyprázdňujú',
      many: '{n} adresy sa vyprázdňuje',
      other: '{n} adries sa vyprázdňuje'
    },
    standaloneHint: 'Tento uzol nemá klaster: ešte nebol nainštalovaný. Klastre sa vytvárajú ALEBO joinujú pri inštalácii — token vygenerovaný v tabuľke Server niektorého člena treba podať installeru (dev: db:init-cluster / db:init-join).',
    reducedHint: 'Vaše oprávnenia pokrývajú jeden scope, nie celý klaster: inventár flotily — uzly, nastavenia a zariadenia — vidí len ten, kto spravuje klaster.',
    phaseReady: 'Pripravený',
    phaseForming: 'Formuje sa',
    storeMembers: 'Členovia store',
    watermark: 'Prah konvergencie',
    configGeneration: 'Generácia konfigurácie',
    converged: 'zosúladená',
    behind: 'pozadu — {m} / {n}',
    revision: 'Revízia',
    rolesTitle: 'Sieťové roly',
    rolesSubtitle: 'Adresy pre člena v každej triede prevádzky — konektivita žije v sieti hostiteľa',
    roleManagement: 'Management',
    roleLiveMigration: 'Live Migration',
    roleInherited: 'dedí management',
    settingsTitle: 'Nastavenia',
    settingsSubtitle: 'Bezpečnostná politika na úrovni klastra — každý uzol ju vyhodnocuje zo svojej lokálnej repliky',
    taskRetentionTitle: 'Uchovávanie úloh',
    taskRetentionSubtitle: 'Zjednotený GC pre všetky úlohy — ukončené úlohy nad rámec veku alebo stropu sa zbierajú, prebiehajúce nikdy',
    taskRetentionMaxAge: 'Maximálny vek (dni)',
    taskRetentionMaxCount: 'Maximálny počet úloh',
    eventRetentionTitle: 'Retencia udalostí',
    eventRetentionSubtitle: 'GC žurnálu — politika nezávislá od úloh: úloha je front, udalosť je pamäť',
    eventRetentionMaxAge: 'Maximálny vek (dni)',
    eventRetentionMaxCount: 'Maximálny počet udalostí',
    spaceThresholdsTitle: 'Prahy miesta',
    spaceThresholdsSubtitle: 'Kedy sa plniace sa úložisko dostane do žurnálu (a notifikácií)',
    spaceLowPct: 'Varovanie od (% využité)',
    spaceCriticalPct: 'Kritické od (% využité)',
    spaceOrderError: 'Kritické nemôže byť pod varovaním',
    spaceThresholdsHint: 'Konfigurujú sa len vstupy: výstup odvodzuje engine, 5 bodov pod každým prahom, aby sa úložisko stojace na hranici nikdy nestalo metronómom',
    failoverReserveTitle: 'Rezerva failoveru',
    failoverReserveSubtitle: 'Admission control N+1 — RAM držaná voľná, aby klaster po strate uzlov dokázal reštartovať vlastnú záťaž',
    failoverReserveTolerate: 'Počet uzlov, ktorých stratu tolerovať',
    failoverReserveOff: '0 — rezerva vypnutá: žiadne spustenie sa nikdy neodmietne pre kapacitu failoveru',
    failoverReserveOn: 'Spustenie, ktoré by narušilo rezervu, sa odmietne s chybou 412, ktorá vysvetlí čísla',
    networkShapingTitle: 'Spravodlivosť pásma',
    networkShapingSubtitle: 'Tri typologické váhy shaping stromu na uplink — pôsobia len pri súperení o pásmo',
    networkShapingRest: 'Váha zvyšku (riadiaca rovina, storage, repliky)',
    networkShapingOverlay: 'Váha overlay sietí',
    networkShapingLiveMigration: 'Váha live migration',
    networkShapingHint: 'Zaručený podiel = váha / súčet troch (predvolené 300 / 100 / 200, každá od 1 do 10000); na voľnom spoji si každá trieda môže vziať celé pásmo',
    debugModeTitle: 'Režim debug',
    debugModeSubtitle:
      'Podrobné chyby vo všeobecných upozorneniach GUI — aby bolo vidno skutočnú príčinu, keď „neúspešná“ akcia v skutočnosti uspela',
    debugModeLabel: 'Režim debug povolený',
    debugModeOn: 'Všeobecné chybové upozornenia dopĺňajú príčinu na pozadí — interné detaily viditeľné pre každého operátora',
    debugModeOffHint: 'Vypnutý — všeobecné chybové upozornenia zostávajú všeobecné, bez interných detailov',
    nodeDetailsAction: 'Detaily uzla',
    node: {
      docTitle: 'Uzol',
      notFound: 'Uzol sa nenašiel',
      tabOverview: 'Prehľad',
      tabStats: 'Štatistiky',
      tabNetwork: 'Sieť',
      tabSettings: 'Lokálne nastavenia',
      identityTitle: 'Identita',
      heartbeatTitle: 'Heartbeat',
      ysqlPort: 'Port YSQL',
      revision: 'Revízia konfigurácie',
      versionsTitle: 'Pozorované verzie',
      heartbeatSubtitle: 'Posledný stav, ktorý uzol nahlásil sám o sebe',
      cpuTitle: 'CPU',
      cpuModelTitle: 'Model CPU',
      memoryTitle: 'Pamäť',
      hugePagesTitle: 'Obrovské stránky',
      hugePagesPool: '{size}: voľné {free} z {total}',
      hugePagesNone: 'Žiadny pool',
      hugePagesNoneHint: 'Uzol nemá rezervované obrovské stránky: VM, ktoré ich žiadajú, sa tu nemôžu spustiť. Pool sa deklaruje na uzle parametrami kernelu hugepagesz a hugepages alebo zápisom do nr_hugepages.',
      usageTitle: 'Aktuálne využitie',
      usageMem: 'RAM {n} MiB',
      usageUnknown: 'nepozorované — žiadna čerstvá vzorka',
      statsNoData: 'V intervale nie sú žiadne údaje — série uzla vzorkuje uzol sám a poskytuje ich lokálne.',
      observedTitle: 'Pozorovaný stav',
      observedSubtitle: 'Služby a assety lokálne pre uzol, ako ich vidí worker'
    },
    editRolesTitle: 'Upraviť sieťové roly',
    memberNode: 'Uzol',
    memberIp: 'IP adresa',
    addMember: 'Pridať člena',
    lmInherit: 'Použiť adresy managementu',
    roleIpHint: 'Pridávanie a odoberanie členov je voľné; zmena IP existujúceho člena na mieste sa odmieta — tok migrácie IP príde v neskoršom rounde.',
    roleError: 'Roly sa nepodarilo aktualizovať',
    nodesTitle: 'Uzly',
    addNodeTitle: 'Pridať uzol do klastra',
    addNode: 'Pridať uzol',
    addNodeError: 'Uzol sa nepodarilo predregistrovať',
    nodeName: 'Názov uzla',
    nodeNameHint: 'musí sa zhodovať s názvom zvoleným pri inštalácii',
    nodeIp: 'IP managementu',
    colName: 'Názov',
    colPhase: 'Fáza',
    colServices: 'Služby',
    colWatermark: 'Watermark',
    colLastSeen: 'Posledný kontakt',
    colUps: 'UPS',
    upsCordonChip: 'kordón UPS',
    upsCordonTip: 'Uzol sa odsúdil na základe faktov svojej UPS ({time}): kordón sám uvoľní, keď bude sieť stabilná a batéria nabitá',
    upsUnreachable: 'UPS nedostupná',
    upsOnBattery: 'Na batérii',
    upsOnLine: 'Na sieti',
    upsLowBattery: 'slabá batéria',
    upsNoEstimateChip: 'výdrž neodhadnutá',
    upsNoEstimateTip: 'UPS nepublikuje odhad výdrže: uzol je odsúdený iba príznakom LB (slabá batéria) UPS — nastavte battery.runtime.low / LB na samotnej UPS',
    upsLaneTip: 'Cesta vypnutia UPS od {since}: odsúdený kvôli {by}',
    upsUnit: 'jednotka',
    upsStatus: 'stav NUT',
    upsLoad: 'záťaž',
    upsOnBatterySince: 'na batérii od',
    upsOnLineSince: 'na sieti od',
    upsError: 'chyba',
    upsObservedAt: 'pozorované',
    upsNone: 'žiadna jednotka UPS tento uzol neobsluhuje',
    upsBy: {
      runtime: 'výdrž pod prahom',
      lowBattery: 'príznak LB UPS',
    },
    upsLane: {
      evacuate: 'evakuácia',
      local: 'vypnutie na mieste',
    },
    upsPhase: {
      draining: 'drain',
      stoppingGuests: 'zastavovanie hostí',
      stoppingServices: 'zastavovanie služieb',
      poweredOff: 'vypnuté',
    },
    upsTitle: 'UPS (NUT)',
    upsSubtitle: 'Jednotky UPS a prahy: uzol odsúdený pri výdrži ≤ prah alebo príznaku LB (vždy rešpektovaný), obnovenie s hysterézou',
    upsRuntimeThreshold: 'Prah výdrže (s)',
    upsRuntimeThresholdHint: 'Na batérii s odhadovanou výdržou ≤ prah sa uzol vypne v poradí (predvolené 300)',
    upsResumeStable: 'Sieť stabilná počas (s)',
    upsResumeStableHint: 'Obnovenie len s neprerušenou sieťou aspoň toľko sekúnd (predvolené 60)',
    upsResumeCharge: 'Minimálne nabitie pri obnovení (%)',
    upsResumeChargeHint: 'A batéria nabitá aspoň na toto percento (predvolené 25)',
    upsPolicyNote: 'Príznak LB (slabá batéria) UPS odsudzuje vždy a nedá sa vypnúť; prah na čas strávený na batérii neexistuje. Každá jednotka môže tri čísla prepísať.',
    upsUnitNew: 'nová jednotka',
    upsUnitSelectors: '{n} selektor(y) podľa tagov (iba CLI)',
    upsUnitName: 'Názov jednotky',
    upsUnitMode: 'Režim',
    upsModeExternal: 'externá (cudzí upsd)',
    upsModeManaged: 'spravovaná (UPS pripojená k uzlu)',
    upsUnitUpsname: 'Názov NUT (upsname)',
    upsUnitHost: 'Hostiteľ upsd',
    upsUnitAttachedNode: 'Pripojený uzol',
    upsUnitDriver: 'Ovládač NUT',
    upsUnitDriverHint: 'usbhid-ups, nutdrv_qx, snmp-ups, …',
    upsUnitDevice: 'Zariadenie ovládača',
    upsUnitDeviceHint: 'riadok port= v ups.conf: prázdne = auto',
    upsUnitPort: 'Port upsd',
    upsUnitServedNodes: 'Obsluhované uzly',
    upsUnitServedNodesHint: 'názvy uzlov oddelené čiarkami (selektory podľa tagov cez CLI)',
    upsUnitOverrideHint: 'prázdne = predvolené klastra',
    upsUnitAdd: 'Pridať jednotku',
    unreachableSince: 'Nedostupný — posledný heartbeat {time}',
    overlaysChip: 'overlay',
    overlaysBehind: 'Overlay dataplane ešte nezrealizoval aktuálnu overlay konfiguráciu',
    overlaysError: 'Posledný zosúlaďovací prechod overlay zlyhal: {error}',
    storeChip: 'store',
    phase: {
      'pending-join': 'Čaká na join',
      'joining': 'Pripája sa',
      'member': 'Člen'
    },
    tokenTitle: 'Join token',
    tokenOnce: 'Zobrazený len teraz — hneď si ho skopírujte, už sa nebude dať prečítať',
    copy: 'Kopírovať',
    copied: 'Skopírované',
    close: 'Zavrieť',
    revokeTitle: 'Odvolať predregistráciu',
    revoke: 'Odvolať',
    revokeError: 'Registráciu sa nepodarilo odvolať',
    promote: 'Povýšiť na store member',
    demote: 'Odobrať rolu store-member',
    troubleshoot: 'Riešenie problémov',
    promoteTitle: 'Povýšiť na store member',
    demoteTitle: 'Odobrať rolu store-member',
    promoteHint: 'Uzol vstúpi do kvora masterov YugabyteDB. Skutočná HA vyžaduje troch členov store.',
    demoteHint: 'Uzol opustí kvorum masterov a zastaví svoje store služby.',
    storeError: 'Zmena roly store-member bola odmietnutá',
    attest: 'Atestovať ako vypnutý…',
    attestTitle: 'Atestovať uzol ako vypnutý',
    attestSubmit: 'Atestovať ako vypnutý',
    attestConfirm: 'Vyhlasujete tento uzol za vypnutý na vlastné riziko: atestovanie uzla, ktorý v skutočnosti žije, riskuje VM v dvojitom behu. Jeho úlohy sa označia ako zlyhané a authority jeho VM sa stanú prenosnými.',
    attestError: 'Atestácia bola odmietnutá',
    attestedChip: 'atestovane vypnutý',
    maintenanceChip: 'údržba',
    guestToolsChip: 'TVirt Guest Tools (asset ISO lokálny pre uzol)',
    maintenanceEnter: 'Zapnúť údržbu',
    maintenanceExit: 'Vypnúť údržbu',
    maintenanceEnterTitle: 'Zapnúť údržbu',
    maintenanceExitTitle: 'Vypnúť údržbu',
    maintenanceEnterSubmit: 'Zapnúť údržbu',
    maintenanceExitSubmit: 'Vypnúť údržbu',
    maintenanceEnterConfirm: 'Uzol sa odstaví a vyprázdni: sieťové služby a inštancie App, ktorých authority drží, sa prenesú (inštancie za studena: tu zastavené a zožaté, znovu vytvorené na cieľovom uzle — výpadok), bežiace VM sa migrujú naživo, kde sa dá, inak sa elegantne zastavia, rozpracované úlohy sa dokončia, nová práca čaká a zastavené VM strácajú svoju authority — Proximity ich znovu umiestni pri ďalšom spustení. Po skončení údržby sa nič nevráti samo.',
    maintenanceExitConfirm: 'Uzol sa vráti do práce a Proximity ho opäť zvažuje pri umiestňovaní. VM sa vrátia, až keď ich spustíte.',
    maintenanceError: 'Požiadavka na údržbu bola odmietnutá',
    maintenancePlanTitle: 'Plán evakuácie',
    maintenancePlanLoading: 'Výpočet plánu evakuácie…',
    maintenancePlanError: 'Plán evakuácie sa nepodarilo načítať — drain aj tak zmigruje, čo sa dá, a zvyšok zastaví.',
    maintenancePlanEmpty: 'Na tomto uzle nie je čo evakuovať — žiadna aktívna sieťová služba, žiadna inštancia App požadovaná v behu, žiadna bežiaca VM.',
    maintenancePlanSummary: '{migrate} objektov bude migrovať (VM, sieťové služby, inštancie App), {stop} sa zastaví alebo zostane, kde je.',
    maintenancePlanReserve_ok: 'Rezerva failoveru po vyprázdnení: neporušená — zostáva {headroom} GiB spustiteľných pri tolerancii straty {n} uzla/uzlov.',
    maintenancePlanReserve_eroded: 'Rezerva failoveru po vyprázdnení: takmer vyčerpaná — zostáva už len {headroom} GiB z {reserve} GiB držaných voľných pre {n} zlyhanie/í uzla.',
    maintenancePlanReserve_exhausted: 'Rezerva failoveru po vyprázdnení: VYČERPANÁ — chýba {headroom} GiB z {reserve} GiB potrebných na tolerovanie {n} zlyhania/í uzla. Kým je tento uzol mimo, nové spustenia VM budú odmietané.',
    maintenancePlanReserve_unknown: 'Rezerva failoveru po vyprázdnení: nemožno vypočítať — žiadny zostávajúci uzol nedeklaroval pamäť.',
    maintenancePlanReserveHugePages: 'Obrovské stránky veľkosti {size} po vyprázdnení — voľné: {free} z {capacity}, požadované ako rezerva: {reserve}.',
    maintenancePlanActionMigrate: 'migruje sa',
    maintenancePlanActionMigrateWarning: 'migruje sa (porušené soft pravidlo)',
    maintenancePlanActionStop: 'zastaví sa',
    maintenancePlanActionBlocked: 'zablokovaná',
    maintenancePlanKindVm: 'VM',
    maintenancePlanKindNetsvc: 'sieťová služba',
    maintenancePlanKindApp: 'inštancia App',
    maintenancePlanColdMove: 'Presun za studena: pod sa tu zastaví a zožne a worker cieľového uzla ho znovu vytvorí — výpadok do ďalšieho passu cieľového workera.',
    caFingerprint: 'Fingerprint CA klastra',
    staleChip: 'neaktuálny',
    troubleshootTitle: 'Riešenie problémov store',
    restartStore: 'Reštartovať store služby',
    restartHint: 'Ak store vystrája, reštartujte jeho služby. Pokročilé — používajte opatrne.',
    restartQueued: 'Úloha reštartu zaradená do frontu',
    restartError: 'Služby sa nepodarilo reštartovať',
    svcActive: 'aktívna',
    svcWanted: 'žiadaná, nie aktívna',
    svcStopped: 'zastavená',
    noServices: 'Žiadne hlásené služby'
  },
  clusterDevices: {
    gpusTitle: 'GPU / PCIe',
    gpusSubtitle: 'Inventár GPU celého klastra zoskupený podľa modelu — karty pozorované po uzloch, s označenými registráciami a ich značkami',
    usbTitle: 'Zdroje USB',
    usbSubtitle: 'Inventár USB celého klastra zoskupený podľa modelu — zariadenia pozorované po uzloch, s registráciami oboch modelov (podľa zariadenia, podľa portu) a ich značkami',
    markedChip: 'použiteľné pre TVirt: {n}',
    orphanChipGpu: 'osirotené: {n}',
    orphanChipUsb: 'osirotené: {n}',
    colNode: 'Uzol',
    colRegistration: 'Registrácia',
    noRegsHint: 'Žiadna registrácia — zariadenie sa označuje ako „použiteľné pre TVirt“ v dialógu uzla (Uzly › uzol › Nastavenia).',
    colDevice: 'Zariadenie',
    colObserved: 'Pozorované',
    colRegs: 'Registrácie',
    regsNone: 'žiadna',
    colPci: 'Adresa PCIe',
    colIdentity: 'Identita / port',
    colClasses: 'Triedy (značky)',
    colActions: 'Akcie',
    manageOnNode: 'Spravovať na uzle {node} (označovanie žije v dialógu uzla)',
    introTitle: 'Klastrový inventár zariadení USB a PCIe použiteľných pre TVirt©.',
    introStep1: '1. Uzly si samy objavujú svoje GPU a zariadenia USB (súpis v heartbeate).',
    introStep2: '2. Zariadenie sa označí ako „použiteľné pre TVirt“ v dialógu UZLA (Uzly › uzol › Nastavenia) — označenie ho priviaže k vfio a zaregistruje ho tu.',
    introStep3: '3. Tu dávate registráciám ich TRIEDY cez značky (napr. gpu_class=compute): požiadavky VM si vyžiadajú triedu a plánovač vyberie uzol s voľným kompatibilným zariadením.',
    colMode: 'Režim',
    colState: 'Stav',
    colNotes: 'Poznámky',
    colTags: 'Značky',
    modeDevice: 'podľa zariadenia',
    modePort: 'podľa portu',
    usable: 'použiteľné',
    orphanGpu: 'osirotená',
    orphanUsb: 'osirotené',
    hubChip: 'hub',
    orphanPortsTitle: 'Registrácie podľa portu bez pripojeného zariadenia — znova pripojte zariadenie alebo ich odznačte z uzla',
    gpusEmpty: 'Na žiadnom uzle zatiaľ nebola pozorovaná žiadna GPU',
    usbEmpty: 'Na žiadnom uzle zatiaľ nebolo pozorované žiadne zariadenie USB'
  },

  // Vocabolario condiviso dei form impostazioni (refactoring 2026-07-24): i campi
  // security alimentano la card della pagina Cluster, i campi nodo la pagina
  // node-settings — la pagina /system/settings per cui nacquero è morta.
  settings: {
    passwordMinLength: 'Minimálna dĺžka hesla',
    sessionIdle: 'Časový limit nečinnosti relácie (minúty)',
    lockoutThreshold: 'Zablokovanie po neúspešných pokusoch',
    lockoutDuration: 'Trvanie zablokovania (minúty)',
    keyboardLayout: 'Rozloženie klávesnice',
    keyboardLayoutHint: 'napr. it, en-us — prázdne pre predvolené QEMU',
    syslogEndpoint: 'Endpoint syslogu',
    syslogEndpointHint: 'host:port — prázdne vypne preposielanie',
    syslogTls: 'TLS',
    maxQueued: 'Maximum úloh vo fronte',
    concurrency: 'Súbežnosť workera',
    concurrencyHint: 'Worker ju aplikuje za behu',
    notesTitle: 'Poznámky',
    save: 'Uložiť',
    saved: 'Nastavenia uložené',
    saveError: 'Nastavenia sa nepodarilo uložiť'
  },
  localSettings: {
    derivedChip: 'odvodený',
    derivedTip: 'Toto device VLASTNÍ derivácia fabric (H2): editor sa ho odmieta dotknúť — upravte fabric (alebo kabeláž) a znovu aplikujte, alebo si ho vezmite späť nižšie.',
    takeOwnership: 'Prevziať vlastníctvo',
    takeOwnershipTitle: 'Prevziať vlastníctvo (take-ownership)',
    takeOwnershipConfirm: '{name} opúšťa blok fabric a stáva sa znovu RUČNÝM deviceom, ktoré riadi tento editor. Uzol sa stane odchýleným a najbližší apply derivácie na ňom odmietne (manualConflict), kým ho nepremenujete alebo neodstránite — alebo neopravíte fabric.',
    nodeSettingsTitle: 'Nastavenia uzla',
    nodeSettingsSubtitle: 'To, čo tento uzol aplikuje — front úloh, konzola, preposielanie logov — plus jeho značky a poznámky',
    baseTitle: 'Rezervy hostiteľa (TVirt Proximity)',
    baseSubtitle: 'CPU a RAM rezervované pre operačný systém hostiteľa — vstupy empirickej kapacity, s ktorou Proximity umiestňuje VM',
    baseMemory: 'Základná RAM (MiB)',
    baseMemoryHint: 'Pozorovaný celok: {total} MiB. Použiteľné pre VM = celok − základ − RAM zapnutých VM umiestnených sem.',
    baseMemoryHintNoTotal: 'Použiteľné pre VM = pozorovaný celok − základ − RAM zapnutých VM umiestnených sem.',
    baseCpu: 'Základné jadrá CPU',
    baseCpuHint: 'Pozorované logické CPU: {total}. Používajú sa len ako váha pri ranku — overcommit vCPU je normálny.',
    baseCpuHintNoTotal: 'Používajú sa len ako váha pri ranku — overcommit vCPU je normálny.',
    baseHint: 'RAM je tvrdý vstupný gate: VM, ktorá sa nezmestí do použiteľnej RAM, sa odmietne s výrečnou chybou. Na hostiteľoch s členmi store alebo démonmi Ceph základ zvýšte.',
    placementTitle: 'Fyzické umiestnenie',
    placementSubtitle: 'Kde tento server fyzicky stojí — deklarované raz, nech to potrebuje čokoľvek',
    placementHint: 'Umiestnenie riadi hierarchiu CRUSH každého klastra Ceph s OSD na tomto serveri: uloženie zmeny zosúladí ich mapy cez úlohu (host → rack → … → root). Čiastočné deklarácie sú legálne — prázdne úrovne kolabujú. Názvy sa zdieľajú naprieč celou mapou: dva servery v tom istom racku deklarujú rovnaký názov racku.',
    placementNameInvalid: 'Názov bezpečný pre DNS (malé písmená, číslice, spojovníky)',
    placementEmpty: 'Prázdne = nedeklarované',
    placementLevel: {
      chassis: 'Šasi',
      rack: 'Rack',
      row: 'Rad',
      pdu: 'PDU',
      pod: 'Pod',
      room: 'Miestnosť',
      datacenter: 'Dátové centrum',
      zone: 'Zóna',
      region: 'Región'
    },
    cablingTitle: 'Kabeláž',
    cablingSubtitle: 'Ku ktorému portu prepínača je pripojené každé rozhranie — deklarácia žije na uzle (Annex O.9)',
    cablingHint: 'Jeden kábel na NIC, jeden kábel na port v celej flotile (API odmietne s menom držiteľa). Kabelovať do portu, ktorý je členom LAGG, je legálne — je to prípad bondu: budúca derivácia ho vykreslí ako LACP.',
    cablingInterface: 'Rozhranie',
    cablingNotCabled: '— nepripojené —',
    cablingNoInterfaces: 'Nepozorované žiadne sieťové rozhranie',
    disksTitle: 'Disky',
    disksSubtitle: 'Pozorované blokové zariadenia — jeden sken na zosúlaďovací prechod; tu označte disky použiteľné ako OSD Ceph (N.15: spôsobilosť je explicitná)',
    colDataDisk: 'Dátový disk',
    dataDisksHint: 'Zaškrtnutie zariadenia ho deklaruje ako použiteľné pre OSD; sériové číslo je jeho identitný pin — skopírované z hardvéru, keď ho disk hlási, inak vyrazené (tvirt-…). Dialóg registrácie Ceph ponúka len deklarované disky.',
    diskDeclaredSerial: 'deklarovaný',
    diskNotObserved: 'deklarovaný, ale nepozorovaný — znova pripojte zariadenie alebo zrušte zaškrtnutie',
    noDisks: 'Zatiaľ nepozorované žiadne blokové zariadenie',
    colSerial: 'Sériové číslo',
    colModel: 'Model',
    colSize: 'Veľkosť (GiB)',
    colDiskType: 'Typ',
    colInUse: 'V použití',
    colObservedAt: 'Pozorované',
    diskInUse: 'v použití',
    diskFree: 'voľný',
    diskMounted: 'pripojený',
    diskPartitions: 'partície',
    passthroughTitle: 'Zariadenia passthrough',
    passthroughSubtitle: 'Pozorované GPU a zariadenia USB — tu označte, čo smie TVirt podať VM; označenie registruje identitu zariadenia (round U1+G1)',
    passthroughHint: 'Označenie zariadenie zaregistruje (stabilné id — cieľ značiek a požiadaviek na triedu). Označená GPU má CELÚ IOMMU skupinu naviazanú na vfio-pci naraz — okamžite opúšťa hostiteľa; odznačenie znova naviaže natívny ovládač. Pre USB existujú oba ratifikované modely: podľa zariadenia (vendor+produkt, nech je pripojené kdekoľvek) a podľa fyzického portu (do VM príde čokoľvek, čo je doň zastrčené). USB sa pri označení nebinduje — attach prebieha za behu VM.',
    passthroughGpusTitle: 'GPU / PCIe',
    passthroughUsbTitle: 'USB',
    colUsable: 'Použiteľné pre TVirt',
    colGpu: 'GPU',
    colPciAddress: 'Adresa PCI',
    colDriver: 'Ovládač',
    colVerdict: 'Verdikt',
    gpuEligible: 'Spôsobilá',
    gpuIneligible: 'Nespôsobilá',
    gpuReason: {
      'no-iommu': 'IOMMU nie je na hostiteľovi aktívne',
      'group-spans-slots': 'IOMMU skupina nie je izolovaná: siaha do ďalších slotov',
      'multiple-display': 'IOMMU skupina nie je izolovaná: viac než jedna video funkcia',
      'foreign-function': 'IOMMU skupina nie je izolovaná: obsahuje cudziu funkciu'
    },
    vfioNotReady: 'IOMMU nie je na tomto hostiteľovi aktívne: žiadna GPU nie je spôsobilá, kým ho hostiteľská platforma nezapne (ISO OEM) — TVirt nikdy neupravuje kernel args za behu.',
    vfioMissingKernelArg: 'IOMMU nie je na tomto hostiteľovi aktívne: firmvér hlási VT-d/AMD-Vi (tabuľka ACPI DMAR/IVRS prítomná), ale chýba kernel arg — pridajte intel_iommu=on (Intel) alebo odstráňte amd_iommu=off (AMD) z command line kernelu a reštartujte. TVirt nikdy neupravuje kernel args za behu.',
    vfioFirmwareDisabled: 'IOMMU nie je na tomto hostiteľovi aktívne: VT-d/AMD-Vi je vypnuté vo firmvéri (žiadna tabuľka ACPI DMAR/IVRS), alebo ho CPU nepodporuje — zapnite ho v nastavení firmvéru, žiadny kernel arg ho nezapne. TVirt nikdy neupravuje hostiteľa za behu.',
    gpuBindError: 'Bind vfio-pci zlyhal na {address}: {error}',
    firewallBridgesTitle: 'Firewall na nespravovaných bridge',
    firewallBridgesSubtitle: 'Ručne postavené bridge na tomto uzle, ktorých setup súhlasí s firewallovými chainmi, ktoré TVirt vykresľuje na pripojených hosťovských NIC',
    firewallBridgesHint: 'TVirt sa cudzieho bridge nikdy nedotýka — chain sa ukotvuje na tap/veth, ktorý vždy patrí TVirtu. Zoznam je brána súhlasu: default-deny a anti-spoofing vedia rozbiť to, čo ručný setup očakáva, takže NIC s firewallom na nespravovanom bridge, ktorý tu NIE JE uvedený, sa odmietne s výrečnou chybou.',
    firewallBridgesEmpty: 'Žiadny nespravovaný bridge nesúhlasí s firewallovými chainmi, ktoré TVirt vykresľuje na tomto uzle.',
    firewallBridgeAdd: 'Pridať bridge',
    firewallBridgeInvalid: 'Nie je to názov linuxového rozhrania (1-15 znakov, bez lomky a medzery)',
    firewallBridgeDuplicate: 'Názov už je v zozname',
    colMarkDevice: 'Podľa zariadenia',
    colMarkPort: 'Podľa portu',
    usbHub: 'hub',
    colUsbId: 'Vendor:Product',
    colPort: 'Port',
    passthroughOrphan: 'osirotené — registrované, ale už nezistené: znova ho pripojte alebo odznačte',
    noGpus: 'Zatiaľ nepozorovaná žiadna GPU',
    noUsb: 'Zatiaľ nepozorované žiadne zariadenie USB',
    networkGeneration: 'Generácia siete',
    applied: 'Aplikovaná',
    converged: 'zosúladená',
    behind: 'pozadu — {m} / {n}',
    notConfigured: 'nenakonfigurované',
    rollbackBody: 'Aplikácia generácie {gen} zlyhala: {error}',
    rolledBackChip: 'rollback vykonaný',
    nicsTitle: 'NIC',
    nicsSubtitle:
      'Evidencia spravovaných NIC — registrácia JE deklaráciou správy: registrovaná NIC bez konfigurácie sa nechytá (clear-if ju explicitne deklaruje ako čistú), neregistrovaného zariadenia sa TVirt nikdy nedotkne',
    addNic: 'Registrovať NIC',
    addNicTitle: 'Registrovať NIC (add-nic)',
    delNic: 'Ukončiť správu',
    delNicTitle: 'Ukončiť správu (del-nic)',
    delNicConfirm:
      'Správa {name} sa končí: záznam v evidencii a jeho konfigurácia sa odstránia a profil TVirt sa zloží — zariadenie zostane tak, ako ho má Linux.',
    nicName: 'Názov zariadenia',
    nicMac: 'Permanentná MAC adresa',
    nicMacHint: 'permanentná hardvérová MAC — stabilná identita zafixovaná nástrojom TVirt Server Installer',
    colObserved: 'Pozorovaná',
    nicObserved: 'pozorovaná',
    nicNotObserved: 'nepozorovaná',
    nicMacMismatch: 'Rozdielna MAC — pozorovaná {mac}',
    noNics: 'Žiadna registrovaná NIC — registráciou zariadenia začnete jeho správu',
    noManagedDevices: 'Žiadne spravované zariadenie — najprv zaregistrujte NIC, všetko sa stavia na evidencii',
    inventoryTitle: 'Pozorované zariadenia',
    inventorySubtitle: 'Aktualizované pri každom zosúlaďovacom prechode workerom uzla — validácia overuje názvy zariadení proti tomuto inventáru',
    colDevice: 'Zariadenie',
    colType: 'Typ',
    colMac: 'MAC',
    colLink: 'Link',
    colSpeed: 'Rýchlosť',
    colTopology: 'Topológia',
    colMtu: 'MTU',
    colAddresses: 'Adresy',
    linkUp: 'up',
    linkDown: 'down',
    lacpDegraded: 'LACP neagreguje',
    noInventory: 'Zatiaľ žiadne hlásené zariadenie',
    interfacesTitle: 'Rozhrania',
    interfacesSubtitle:
      'Konfigurácia L3 registrovaných NIC a deklarovaných logických zariadení — set-if nahrádza celý blok, edit-if upravuje vlastnosti, clear-if ho vyprázdni (explicitné čistenie)',
    colConfig: 'Želaná konfigurácia',
    clean: 'čistá',
    setIf: 'Upraviť adresovanie',
    setIfTitle: 'Upraviť adresovanie (set-if)',
    editIf: 'Upraviť vlastnosti',
    editIfTitle: 'Upraviť vlastnosti (edit-if)',
    clearIf: 'Vyprázdniť konfiguráciu',
    clearIfTitle: 'Vyprázdniť konfiguráciu (clear-if)',
    clearIfConfirm: 'Konfigurácia rozhrania sa vyprázdni. Čisté rozhranie je predpokladom na jeho podriadenie ako člena bondu/bridge alebo parenta VLAN.',
    ip4Mode: 'Režim IPv4',
    ip6Mode: 'Režim IPv6',
    modeUnconfigured: 'Nenakonfigurovaná',
    modeStatic: 'Statická',
    modeDhcp: 'DHCP',
    ip4Addresses: 'Adresy IPv4',
    ip6Addresses: 'Adresy IPv6',
    addressesHint: 'CIDR, oddelené čiarkou',
    gw4: 'Brána IPv4',
    gw6: 'Brána IPv6',
    dns: 'Servery DNS',
    dnsHint: 'oddelené čiarkou — prázdne vynuluje DNS (set-if nahrádza blok)',
    routes4: 'Statické trasy IPv4',
    routes6: 'Statické trasy IPv6',
    routeTo: 'Cieľ (CIDR)',
    routeVia: 'Cez',
    addRoute: 'Pridať trasu',
    routesChip: 'trasy',
    mtu: 'MTU',
    mtuHint: 'prázdne = predvolené ovládačom',
    vlansTitle: 'VLAN',
    addVlan: 'Pridať VLAN',
    addVlanTitle: 'Pridať VLAN (add-vlan)',
    delVlanTitle: 'Odstrániť VLAN (del-vlan)',
    vlanParent: 'Rodičovské rozhranie',
    vlanId: 'ID VLAN',
    vlanPreview: 'Názov zariadenia',
    colParent: 'Parent',
    colVlanId: 'ID',
    noVlans: 'Žiadna deklarovaná VLAN',
    bondsTitle: 'Bondy',
    addBond: 'Pridať bond',
    addBondTitle: 'Pridať bond (add-bond)',
    editBondTitle: 'Upraviť bond',
    editBond: 'Uložiť bond',
    delBondTitle: 'Odstrániť bond (del-bond)',
    bondName: 'Názov bondu',
    members: 'Členovia',
    membersHint: 'členmi musia byť čisté rozhrania (bez konfigurácie L3)',
    bondMode: 'Režim',
    modeActiveBackup: 'active-backup',
    modeLacp: 'LACP (802.3ad)',
    miimon: 'miimon (ms)',
    primary: 'Primárny člen',
    rate: 'Rate LACP',
    hash: 'Politika hashovania pri vysielaní',
    colMembers: 'Členovia',
    colMode: 'Režim',
    noBonds: 'Žiadny deklarovaný bond',
    bridgesTitle: 'Bridge',
    addBridge: 'Pridať bridge',
    addBridgeTitle: 'Pridať bridge (add-bridge)',
    editBridgeTitle: 'Upraviť bridge',
    editBridge: 'Uložiť bridge',
    delBridgeTitle: 'Odstrániť bridge (del-bridge)',
    bridgeName: 'Názov bridge',
    stp: 'STP',
    stpOn: 'STP zapnuté',
    stpOff: 'STP vypnuté',
    colStp: 'STP',
    noBridges: 'Žiadny deklarovaný bridge',
    hostnameTitle: 'Hostname',
    hostname: 'Hostname',
    setHostname: 'Nastaviť hostname',
    setHostnameTitle: 'Nastaviť hostname (set-hostname)',
    hostnameHint: 'Len identita OS — názov uzla v klastri sa nemení',
    notSet: 'nenastavený',
    staticHostsTitle: 'Statické záznamy hosts',
    addStaticHost: 'Pridať záznam',
    addStaticHostTitle: 'Pridať statický záznam hosts',
    delStaticHostTitle: 'Odstrániť statický záznam hosts',
    hostIp: 'IP adresa',
    hostNames: 'Názvy',
    hostNamesHint: 'oddelené čiarkou alebo medzerou',
    colIp: 'IP',
    colNames: 'Názvy',
    noStaticHosts: 'Žiadny statický záznam hosts',
    delConfirm: 'Odstránenie {name} zo želaného dokumentu — worker uzla konverguje s checkpointom NetworkManagera a automatickým rollbackom.',
    remove: 'Odobrať',
    opError: 'Sieťová operácia bola odmietnutá'
  }
}
